const InvoiceIndex = () => import('@/modules/invoices/views/InvoiceIndex.vue')
const NFSeIndex = () => import('@/modules/invoices/views/NFSeIndex.vue')

export default [
  {
    path: '/invoices',
    name: 'invoices.index',
    component: InvoiceIndex,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/nfse',
    name: 'nfse.index',
    component: NFSeIndex,
    meta: { requiresAuthentication: true }
  }
]
